import { useQuery } from '@tanstack/react-query';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { Skeleton } from 'DesignSystem/ui/skeleton';
import { prefCardItemDetailsQuery, usePrefCardCases } from 'pages/preference-cards/api';

import { FrequencyOfUseChart } from './charts/frequency-of-use-chart/frequency-of-use-chart';
import { FrequencyOfUseWeightedChart } from './charts/frequency-of-use-chart/frequency-of-use-weighed-chart';
import { TimeSeriesChart } from './charts/time-series-chart/time-series-chart';
import { TimeSeriesWeightedChart } from './charts/time-series-chart/time-series-weighted-chart';

export function ItemCharts(props: { cardId: string; itemId: string }) {
  const { hasCoPrefCardItemFrequencyOfUseWeightedChart, hasCoPrefCardItemTimeSeriesWeightedChart } = useFlags();
  const { data: item, isLoading } = useQuery(prefCardItemDetailsQuery(props.cardId, props.itemId, true));
  const { data: caseCount } = usePrefCardCases(
    props.cardId,
    {
      for_preference_card_client_item_master_ids: props.itemId,
      page_size: '0',
    },
    {
      select: (data) => data.result_set_size,
    }
  );

  if (isLoading) {
    return (
      <div className="h-9">
        <Skeleton className="mx-1 my-2 h-7 w-full rounded-lg bg-slate-200" />
      </div>
    );
  }

  return (
    <>
      {hasCoPrefCardItemFrequencyOfUseWeightedChart ? (
        <FrequencyOfUseWeightedChart frequency={item?.frequency_of_use ?? []} caseCount={caseCount ?? 0} />
      ) : (
        <FrequencyOfUseChart frequency={item?.frequency_of_use ?? []} caseCount={caseCount ?? 0} />
      )}

      {hasCoPrefCardItemTimeSeriesWeightedChart ? (
        <TimeSeriesWeightedChart timeSeries={item?.average_used_range ?? []} />
      ) : (
        <TimeSeriesChart timeSeries={item?.average_used_range ?? []} />
      )}
    </>
  );
}
